<template>
	<div>
		<v-row v-if="!authenticated">
			<v-col v-if="!appointmentInfo.recordingPermissionGiven">
				<AllowRecording v-if="view == 'participant'" v-on:cancel="showRecordingPermissionDialog = false" :appointment="appointment"></AllowRecording>
			</v-col>
			<v-alert v-else type="error" outlined>Something has gone wrong establishing this call. Please contact meisterworks. Please contact meisterworks.</v-alert>
		</v-row>	
		<v-row v-if="authenticated">
			<v-col cols="12" md="3" sm="4" v-if="drawer">
					<v-card
					class="mx-auto mt-1"
					tile>
						<ClientSidePanel 
						v-if="view == 'client'" 
						:live="live"
						:recording="recording"
						:appointment="appointmentInfo" 
						:project="projectInfo" 
						:user="user" 
						:participant="participantInfo" 
						:shareScreen = "shareScreen"
						v-on:startScreenShare="showShareScreenDialog = true"
						v-on:endShareScreen="shareScreen = false"
						v-on:endVideo="live = false" 
						></ClientSidePanel>				
				
						<ParticipantSidePanel 
						v-if="view == 'panelmember'"  
						:live="live"
						:user="user" 
						:participant="userInfo" 
						:recording="recording"
						:appointment="appointmentInfo" 
						:project="projectInfo" 
						:shareScreen = "shareScreen"
						v-on:startScreenShare="showShareScreenDialog = true"
						v-on:endShareScreen="shareScreen = false"
						v-on:endVideo="live = false" 
						></ParticipantSidePanel>
					</v-card>
			</v-col>		
			<v-col class="">			
				<v-btn color="primary" absolute small fab style="margin-left:-5px" @click.stop="drawer = !drawer"><v-icon>mdi-arrow-left-right-bold-outline</v-icon></v-btn>
	
				<Video	
					:roomIdentity="appointment"
					:live="live"
					:joinAs="joinAs"
					:shareScreen="shareScreen"
					v-on:videoStarted="videoStarted"
					v-on:videoEnded="videoEnded"
					v-on:screenSharingStarted="screenSharingStarted"
					v-on:screenSharingEnded="screenSharingEnded"
					v-on:startRecording="recordingStarted"
					v-on:endRecording="recordingEnded"
					v-on:left="participantLeft"
				></Video>
			</v-col>		
			<v-dialog v-model="showShareScreenDialog" width="500">
				<ShareScreen v-on:cancel="showShareScreenDialog = false" v-on:complete="showShareScreenDialog = false; shareScreen = true "></ShareScreen>
			</v-dialog>

		</v-row>
	</div>
</template>

<script>
	import Vuex from 'vuex'
	import Video from "../video/Video";
	import ClientSidePanel from "../video/ClientSidePanel";
	import ParticipantSidePanel from "../video/ParticipantSidePanel";
	import ShareScreen from "../video/ShareScreen";
	import AllowRecording from "../video/AllowRecording";

	import firebase from "firebase";
	export default {
		name: "VideoAppointment",
		components: {
			Video: Video,
			ParticipantSidePanel: ParticipantSidePanel,
			ClientSidePanel: ClientSidePanel,
			ShareScreen: ShareScreen,
			AllowRecording: AllowRecording
		},
		props: {
			appointment: {type: String}
		},
		data: () =>{
			return {
				recording: false,
				shareScreen: false,
				live: true,
				leftUsers: [],
				joinedUsers: [],
				showShareScreenDialog: false,
				drawer: true
			}	
		}, 
		computed: {
			...Vuex.mapState({
				view: state => state.auth.view,
				user: state => state.auth.user,
				userInfo: state => state[state.auth.view].user,
				participantInfo: function(state){ 
					if( !this.appointmentInfo ){ return; }
					if( this.view == 'client' ){
						let uId = this.appointmentInfo.participant;
						return state[this.view].panelists.find( u => u.id == uId );
					}
				},
				appointmentInfo: function( state ){
					let aId = this.appointment;

					return state[state.auth.view].appointments.find( a => a.id == aId );
				},
				projectInfo: function(state){
					if( !this.appointmentInfo ){ return; }

					let pId = this.appointmentInfo.project;
					return state[state.auth.view].projects.find( p => p.id == pId );
					
				},
			}),
			authenticated: function(){
				if( !this.appointment ){
					return false;
				} 
				if( this.view == 'panelmember' && this.appointmentInfo.participant == this.user.uid ){
					return true;
				}
				if( this.view == 'client' && this.projectInfo.users[this.user.uid] == "client" ){
					return true
				}
				if( this.view == 'admin'){
					return true
				}
				return false;
			},
			joinAs(){
				if( this.view == "panelmember" ){
					return "participant"
				}
				else{

					if( this.appointmentInfo.videoMeeting.moderator == this.user.uid ){
						return "moderator";
					}
					else{
						return "observer";
					}
				}
			}
		},
		methods: {
			videoStarted(sid){
				var self = this;
				var appointment = self.appointmentInfo;
				let now = firebase.firestore.Timestamp.fromDate(new Date());
				var roomSids = appointment.roomSids || [];
				roomSids.push( sid )
				var videoMeeting = appointment.videoMeeting || {};
				videoMeeting.roomSids = roomSids;
				videoMeeting.events = videoMeeting.events || [];
				videoMeeting.events.push( {
					user: self.user.uid,
					type: self.view, 
					event: "joined", 
					timestamp: now
				} )
				self.$store.dispatch("updateDoc", {
					doc: "appointments/"+self.appointment,
					action: "update",
					data: {videoMeeting: videoMeeting }
				})
			},
			videoEnded(){
				this.live = false;			
			},
			participantLeft(){
				var self = this;
				var appointment = self.appointmentInfo;
				var videoMeeting = appointment.videoMeeting || {};
				let now = firebase.firestore.Timestamp.fromDate(new Date());
				videoMeeting.events = videoMeeting.events || [];
				videoMeeting.events.push( {
					user: self.user.uid,
					type: self.view, 
					event: "left", 
					timestamp: now
				} )
				if( self.joinAs == "observer" ){
					videoMeeting.observers = videoMeeting.observers.filter( o => o.id !== self.user.uid )
				}
				self.$store.dispatch("updateDoc", {
					doc: "appointments/"+self.appointment,
					action: "update",
					data: {videoMeeting: videoMeeting }
				})
			},
			recordingStarted(){
				this.recording = true;
			},
			recordingEnded(){
				this.recording = false;
			},
			screenSharingStarted(){
				var self = this;
				var appointment = self.appointmentInfo;
				var videoMeeting = appointment.videoMeeting || {};
				let now = firebase.firestore.Timestamp.fromDate(new Date());
				videoMeeting.events = videoMeeting.events || [];
				videoMeeting.events.push( {
					user: self.user.uid,
					type: self.view, 
					event: "screenshareStarted", 
					timestamp: now
				} )
				self.$store.dispatch("updateDoc", {
					doc: "appointments/"+self.appointment,
					action: "update",
					data: {videoMeeting: videoMeeting }
				})

			},
			screenSharingEnded(){
				this.shareScreen = false;
				var self = this;
				var appointment = self.appointmentInfo;
				var videoMeeting = appointment.videoMeeting || {};
				let now = firebase.firestore.Timestamp.fromDate(new Date());
				videoMeeting.events = videoMeeting.events || [];
				videoMeeting.events.push( {
					user: self.user.uid,
					type: self.view, 
					event: "screenshareEnded", 
					timestamp: now
				} )
				self.$store.dispatch("updateDoc", {
					doc: "appointments/"+self.appointment,
					action: "update",
					data: {videoMeeting: videoMeeting }
				})
			}
		}
	}
</script>